const { windowLoaded } = await import(`./modules/general.js?ver=${paths.cachebuster}`);
const { initMenu } = await import(`./modules/menu.js?ver=${paths.cachebuster}`);

async function main() {
  await windowLoaded();

  try {
    initMenu();
  } catch (err) {
    console.error(err);
  }
}

main();
